import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import axios from 'axios';
import { API } from '../App';

const BlogPage = () => {
  const [articles, setArticles] = useState([]);
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [articlesRes, settingsRes] = await Promise.all([
        axios.get(`${API}/articles?status=published`),
        axios.get(`${API}/settings`)
      ]);
      setArticles(articlesRes.data);
      setSettings(settingsRes.data);
    } catch (error) {
      console.error('Error fetching blog data:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div>
        <Navbar />
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', paddingTop: '5rem' }}>
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-cyan-600"></div>
        </div>
      </div>
    );
  }

  if (settings?.blog_show_coming_soon) {
    return (
      <div>
        <Navbar />
        <div className="page-header">
          <div className="container">
            <h1 data-testid="page-title">Super Insight Blog</h1>
          </div>
        </div>
        <section className="py-8 container text-center">
          <div className="card" style={{ maxWidth: '600px', margin: '0 auto' }}>
            <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>🚀</div>
            <h2 style={{ marginBottom: '1rem' }}>Coming Soon</h2>
            <p style={{ color: 'var(--muted-foreground)', fontSize: '1.125rem' }}>We're preparing insightful articles for you. Stay tuned!</p>
          </div>
        </section>
        <Footer />
      </div>
    );
  }

  return (
    <div>
      <Navbar />
      
      <div className="page-header">
        <div className="container">
          <h1 data-testid="page-title">Super Insight</h1>
          <p>Expert insights, strategies, and updates for UPSC aspirants</p>
        </div>
      </div>

      <section className="py-8 container">
        {articles.length === 0 ? (
          <div className="card text-center" style={{ maxWidth: '600px', margin: '0 auto' }}>
            <p style={{ color: 'var(--muted-foreground)', fontSize: '1.125rem' }}>No articles published yet. Check back soon!</p>
          </div>
        ) : (
          <div className="grid grid-2">
            {articles.map((article) => (
              <Link key={article.id} to={`/blog/${article.slug}`} className="card" style={{ textDecoration: 'none', color: 'inherit' }} data-testid={`article-${article.id}`}>
                {article.banner_image && (
                  <img src={article.banner_image} alt={article.title} style={{ width: '100%', height: '200px', objectFit: 'cover', borderRadius: '12px', marginBottom: '1rem' }} />
                )}
                <div style={{ fontSize: '0.875rem', color: 'var(--muted-foreground)', marginBottom: '0.5rem' }}>
                  {new Date(article.publish_date || article.created_at).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                </div>
                <h3 style={{ marginBottom: '0.5rem' }}>{article.title}</h3>
                {article.excerpt && (
                  <p style={{ color: 'var(--muted-foreground)', marginBottom: '1rem' }}>{article.excerpt}</p>
                )}
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <span style={{ fontSize: '0.875rem', color: 'var(--primary)', fontWeight: 600 }}>By {article.author}</span>
                  {article.category && (
                    <span style={{ fontSize: '0.875rem', background: 'var(--secondary)', color: 'var(--primary)', padding: '0.25rem 0.75rem', borderRadius: '20px' }}>{article.category}</span>
                  )}
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>

      <Footer />
    </div>
  );
};

export default BlogPage;